import EfImg from 'elem/ui/ef-img';
import { RuleTabModuleIdEnum } from '../Tab';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function PageComp() {
    const { t } = useLang('rule');

    return (
        <div className={`${css['page-comp']}`} id={RuleTabModuleIdEnum.Overview}>
            <EfImg
                className="header-img"
                // pc="https://websiteoss.ecoflow.com/upload/image/1727164643667/pc.jpg"
                // h5="https://websiteoss.ecoflow.com/upload/image/1727164648093/h5.jpg"
                pc="https://websiteoss.ecoflow.com/upload/image/1728460670299/pc.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1728460774146/h5.jpg"
            />
            <div className="header-mask">
                <p className="text">{t('A_text')}</p>
            </div>
        </div>
    );
}
